// extracted by mini-css-extract-plugin
export default {"container":"_4JRX8QhRhqT0tZA3WTDChv","name":"_3oljtgRP2PxmQY3TmLZ89j","reviewsContainer":"_7Aq5GrvIe6IjTFeiU5DIo4","reviewsStarsContainer":"_5oPpixARDmyMispaQCWpw2"};